import { MobileNavProps } from "./MobileNavProps";
import './MobileNav.scss';
import './../Header/NavItems.scss';
import { NavItems } from "../Header/Header";


const MobileNav = (props: MobileNavProps) => {

    return (
        // <div className="mobile-nav-wrapper px-3 d-flex">
        //     <NavItems
        //         iconsHeight={18}
        //         history={history}
        //         className="justify-content-around align-items-center d-flex d-md-none"
        //     />
        // </div>
        <div className="ctaFooterNotification">ffdfdsfdsfdsfdsf fhdsjhfkhdshfkhsdk</div>
    )
}


export default MobileNav;